import { generateContext } from '@/context/utils';
import reducer from '@/storeFinder/context/reducer';
import initialState from '@/storeFinder/context/state';
import actions from '@/storeFinder/context/actions';

const { StoreFinderProvider, useStoreFinderContext } = generateContext(
  'StoreFinderProvider',
  'useStoreFinderContext',
  initialState,
  reducer,
  actions,
);

export { StoreFinderProvider, useStoreFinderContext };
